export default "__VITE_ASSET__B9iXmIvZ__"